/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import {
  clientGetEntityData,
  clientGetLocation,
} from "@services/location.service";
import { getValue } from "@utils/lodash";
import "./index.scss";
import Lottie from "lottie-react";
import warehouse from "@lottie/warehouse.json";
import production from "@lottie/production_plant.json";
import building from "@lottie/building.json";
import hospital from "@lottie/hospital.json";
import Loader from "@components/common/Loader";
import Notfound from "@components/Not-Found";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import CommonBulkUpload from "@components/BulkUpload";
import { useNavigate } from "react-router-dom";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import BulkUploadDropdown from "@components/BulkUploadDropdown";
import PEComplianceLicenseNotfound from "@components/Page-Not-Found/pe-compliance-license-not-found";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import ListViewSvgComponent from "../../../assets/svg-components/list-view";
import GridViewSvgComponent from "../../../assets/svg-components/grid-view";
import ReactTooltip from "react-tooltip";
import { Modal, Spinner } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import DatePicker from "react-datepicker";
import SimpleReactValidator from "simple-react-validator";
import { sanitizeInput } from "@_common/dompurify";
import { createLicenseCertificateReport } from "@services/reports.service";
import { downloadLicenseTaskUpdateTemplate } from "@services/license.service";
import { toast } from "react-toastify";
import moment from "moment";
import DownloadSubheaderSvgComponent from "../../../assets/svg-components/sub-header/download";
import LogSubheaderSvgComponent from "../../../assets/svg-components/sub-header/log";
import React from "react";
import { debounceSearch } from "@_common/common-helper";
import { getSmartFilterListManagementList } from "@services/list-management.service";

export default function TaskLicenseGroup(props: any) {
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */

  const [isLoading, setIsLoading] = useState(true);
  const [complianceTypeList, setComplianceTypeList] = useState([]);
  const [view, setView] = useState("grid");
  const [dropdownOptions] = useState([
    { value: "LOCATION_LICENSES_TASK_UPDATE", label: "Update License Task " },
  ]);

  // Certificate download modal states
  const [isCertificateModalOpen, setIsCertificateModalOpen] = useState(false);
  const [certificateRequest, setCertificateRequest] = useState({
    expiry_date_from: "",
    expiry_date_to: "",
    report_name: "",
    report_description: "",
  });
  const [submitLoading, setSubmitLoading] = useState(false);
  const simpleValidator = useRef(new SimpleReactValidator());
  const [licenseTypeList, setLicenseTypeList] = useState<any>([]);
  const [isAllTime, setIsAllTime] = React.useState("false");
  const [isActive, setIsActive] = useState(true);

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      getData();
    }
    if (getValue(localStorage, `task_license_loc`, "")) {
      localStorage.removeItem("task_license_loc");
    }
    setView(
      getValue(localStorage, `l-view`, "")
        ? getValue(localStorage, `l-view`, "")
        : "grid",
    );
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      sort_by: params.sort_by,
      is_active: true,
      is_user_request: true,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      // let resp = await adminGetListManagementGroupCode("compliance-type");
      let resp = await clientGetEntityData(queryRequest);
      if (resp) {
        // let list = getValue(resp, `data.listItems.length`, 0)>0?getValue(resp, `data.listItems`, []).filter((item:object)=>getValue(item, `is_active`, "")):[]
        // setComplianceTypeList(
        //   getValue(resp, `data.locations`, []).filter((item: object) =>
        //     getValue(item, `is_active`, false)
        //   )
        // )
        setComplianceTypeList(getValue(resp, `data.groups`, []));
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const selectAnimation = (value: string) => {
    switch (value) {
      case "Shops and Commercial Establishments":
        return building;
      case "Factory":
        return production;
      case "Warehouse":
        return warehouse;
      case "Health Care":
        return hospital;
      default:
        return building;
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Certificate Modal Functions                  */
  /* -------------------------------------------------------------------------- */

  const handleCertificateModal = () => {
    setIsCertificateModalOpen(!isCertificateModalOpen);
    if (isCertificateModalOpen) {
      // Reset form when closing
      setCertificateRequest({
        expiry_date_from: "",
        expiry_date_to: "",
        report_name: "",
        report_description: "",
      });
    }
  };

  const handleCertificateSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      return;
    }

    try {
      setSubmitLoading(true);

      const payload: any = {
        report_type: "LICENSE_CONSOLIDATE",
        expiry_date_from:
          isAllTime === "true"
            ? null
            : getValue(certificateRequest, `expiry_date_from`, "")
              ? moment(
                  getValue(certificateRequest, `expiry_date_from`, ""),
                ).format("YYYY-MM-DD")
              : "",
        expiry_date_to:
          isAllTime === "true"
            ? null
            : getValue(certificateRequest, `expiry_date_to`, "")
              ? moment(
                  getValue(certificateRequest, `expiry_date_to`, ""),
                ).format("YYYY-MM-DD")
              : "",
        report_name: certificateRequest.report_name,
        all_time: isAllTime,
        report_description: certificateRequest.report_description,
        is_active: isActive === true ? "true" : "false",
      };

      if (paramsObj.location_id) payload.location_id = paramsObj.location_id;
      if (paramsObj.group_id) payload.group_id = paramsObj.group_id;
      if (paramsObj.region_id) payload.region_id = String(paramsObj.region_id);

      if (paramsObj.license_statuses?.length) {
        payload.license_statuses = paramsObj.license_statuses;
      }

      if (paramsObj.license_type_ids?.length) {
        payload.license_type_ids = paramsObj.license_type_ids;
      }

      if (getValue(props, `permissions`, []).includes("view_all")) {
        payload.is_user_request = "false";
      }

      let resp = await createLicenseCertificateReport(payload);

      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleCertificateModal();
        setSubmitLoading(false);
        navigate(`/activities/task/license/group/report?${queryRequest}`);
      }
    } catch (error) {
      console.error("Error downloading certificate:", error);
      setSubmitLoading(false);
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      await downloadLicenseTaskUpdateTemplate();
    } catch (error) {
      console.error("Error downloading template:", error);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeView = (view: string) => {
    localStorage.setItem("l-view", view);
    setView(view);
  };

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? "true" : "false";
    setIsAllTime(newValue);
  };

  const handleActiveToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsActive(e.target.checked);
  };

  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload = {
      ...params,
      page_no: page_no,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      limit: limit,
      page_no: "1",
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  /* ---------------------------  Entity Mapping Filters  ----------------------------- */

  const [groupList, setGroupList] = useState<any>([]);
  const [regionList, setRegionList] = useState<any>([]);
  const [locationList, setLocationList] = useState<any>([]);

  const [paramsObj, setParamsObj] = useState<any>({
    group_id: "",
    region_id: "",
    location_id: "",
    license_type_ids: [],
    license_statuses: [],
  });

  interface ILocationFilter {
    groupId?: string;
    regionId?: string;
    searchGroup?: string;
    searchRegion?: string;
    searchLocation?: string;
  }

  const getUnique = (arr: any) => {
    const unique = arr.filter(
      (item: any, index: number, self: any) =>
        index === self.findIndex((obj: any) => obj.value === item.value),
    );
    return unique;
  };

  const getLocationFilterData = async (args?: ILocationFilter) => {
    let payload: any = {
      page_no: 1,
      page_size: limit,
      is_active: true,
      is_user_request: true,
      search_text:
        args?.searchGroup || args?.searchRegion || args?.searchLocation || "",
    };
    if (args?.groupId) payload.group_id = args.groupId;
    if (args?.regionId && (args?.searchGroup === "" || !args?.searchGroup))
      payload.region = args.regionId;
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await clientGetEntityData(queryRequest);
      if (resp) {
        if (resp?.data?.groups) {
          const groupOptions = getValue(resp, `data.groups`, [])?.map(
            (item: any) => {
              return { value: item.groupId, label: item.groupName };
            },
          );
          setGroupList((prev: any) => {
            const merged = [...prev, ...groupOptions];
            const unique = getUnique(merged);
            return unique;
          });
          setRegionList([]);
          setLocationList([]);
        }
        if (resp?.data?.regions) {
          const regionOptions = getValue(resp, `data.regions`, [])?.map(
            (item: any) => {
              return { value: item.regionId, label: item.regionName };
            },
          );
          setRegionList((prev: any) => {
            const merged = [...prev, ...regionOptions];
            const unique = getUnique(merged);
            return unique;
          });
          setLocationList([]);
        }
        if (resp?.data?.locations) {
          const locationOptions = getValue(resp, `data.locations`, [])?.map(
            (item: any) => {
              return { value: item.id, label: item.locationName };
            },
          );
          setLocationList((prev: any) => {
            const merged = [...prev, ...locationOptions];
            const unique = getUnique(merged);
            return unique;
          });
        }
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getLocationFilterData();
  }, []);

  useEffect(() => {
    getLocationFilterData({
      groupId: paramsObj.group_id,
      regionId: paramsObj.region_id,
    });
  }, [paramsObj]);

  const handleSearchGroup = debounceSearch(
    (text: string) =>
      getLocationFilterData({
        groupId: paramsObj.group_id,
        regionId: paramsObj.region_id,
        searchGroup: text,
      }),
    500,
  );

  const handleSearchRegion = debounceSearch(
    (text: string) =>
      getLocationFilterData({
        groupId: paramsObj.group_id,
        regionId: paramsObj.region_id,
        searchRegion: text,
      }),
    500,
  );

  const handleSearchLocation = debounceSearch(
    (text: string) =>
      getLocationFilterData({
        groupId: paramsObj.group_id,
        regionId: paramsObj.region_id,
        searchLocation: text,
      }),
    500,
  );

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    setSearchInput(e.target.value);
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      ...params,
      page_no: 1,
      search_text: e.target.value,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    if (!e.target.value) {
      getData();
    }
  };

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  let payload = {
    loc_page_no: getValue(params, `page_no`, "1"),
    loc_search_text: getValue(params, `search_text`, ""),
  };
  let queryRequest = QueryRequestHelper(payload);

  const handleNavigateLicenseGroupReport = () => {
    navigate(`/activities/task/license/group/report?${queryRequest}`);
  };

  const [licenseStatusList] = useState([
    { value: "PENDING", label: "Pending" },
    { value: "COMPLIED", label: "Complied" },
    { value: "NOT_APPLICABLE", label: "Not Applicable" },
    { value: "EXPIRED", label: "Expired" },
  ]);

  const getLicenseType = useCallback(async () => {
    try {
      setIsLoading(true);
      const payload = {
        group_code: "license-type",
        page_no: 1,
        page_size: 100,
      };
      const queryRequest = QueryRequestHelper(payload);
      const response = await getSmartFilterListManagementList(queryRequest);
      if (response.statusCode === 200) {
        const Data = response.data?.listItems;
        const Options = Data?.map((item: any) => {
          return { value: item.id, label: item.text };
        });
        setLicenseTypeList(Options);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    getLicenseType();
  }, [getLicenseType]);

  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        "activities_licenses",
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <div className="dashboard-wrapper__header d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
              <div className="header-parent-icon-holder">
                <MenuActivitySvgComponent />
              </div>

              <div className="title-wrapper">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Activities
                </h6>
                <h4 className="dashbaord-wrapper__header-title">License</h4>
              </div>
            </div>

            <div className="d-flex align-items-center sub-header-icons-holder">
              <div>
                <RightMenuHeaders
                  isSearch={true}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  lineSeperator={true}
                />
              </div>

              {/* Download Certificate Button */}
              <div style={{ margin: "0 2px" }}>
                {/* <button
                  className="btn btn-primary"
                  onClick={handleCertificateModal}
                  style={{
                    padding: "8px 16px",
                    fontSize: "14px",
                    borderRadius: "4px",
                    border: "none",
                    backgroundColor: "#007bff",
                    color: "white",
                    cursor: "pointer"
                  }}
                >
                  Download Certificate
                </button> */}
              </div>

              {getValue(props, `permissions`, []).includes("update") && (
                <div style={{ margin: "0 2px" }}>
                  <BulkUploadDropdown
                    handleDownload={handleDownloadTemplate}
                    dropdownOptions={dropdownOptions}
                  />
                </div>
              )}
              <ReactTooltip id="viewModeLicense" effect="solid" place="bottom">
                {view === "list" ? <>List View</> : <>Grid view</>}
              </ReactTooltip>
              <div
                className="icons-btn cursor-pointer"
                onClick={() =>
                  handleChangeView(view === "list" ? "grid" : "list")
                }
                data-tip
                data-for="viewModeLicense"
              >
                {view === "list" ? (
                  <ListViewSvgComponent />
                ) : (
                  <GridViewSvgComponent />
                )}
              </div>

              {getValue(props, "subTabPermissionList", []).includes(
                "report_analytics_license",
              ) && (
                <>
                  <ReactTooltip
                    id="subHeaderDownload"
                    effect="solid"
                    place="bottom"
                  >
                    Download Certificate Report
                  </ReactTooltip>
                  <button
                    className="icons-btn"
                    data-tip
                    data-for="subHeaderDownload"
                    onClick={() => handleCertificateModal()}
                  >
                    {submitLoading ? (
                      <Spinner size="sm" color="secondary">
                        Loading...
                      </Spinner>
                    ) : (
                      <DownloadSubheaderSvgComponent />
                    )}
                  </button>

                  <ReactTooltip
                    id="subHeaderViewLogs"
                    effect="solid"
                    place="bottom"
                  >
                    View Certificate Report
                  </ReactTooltip>
                  <button
                    className="icons-btn"
                    data-tip
                    data-for="subHeaderViewLogs"
                    onClick={() => handleNavigateLicenseGroupReport()}
                  >
                    <LogSubheaderSvgComponent />
                  </button>
                </>
              )}
            </div>
          </div>

          <div className="compliance-wrapper license-module-main-wrapper">
            <div className="compliance-banner d-flex align-items-center justify-content-around"></div>

            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/configuration/vendors/add"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  add={"false"}
                />
              </div>
            </div>

            {isLoading || !props.permissionAPITriggered ? (
              <Loader />
            ) : getValue(complianceTypeList, `length`, 0) > 0 ? (
              view === "grid" ? (
                <div className="compliance-wrapper__categories-license">
                  {complianceTypeList
                    .filter(
                      (categoriesObj: any) => categoriesObj.group !== null,
                    )
                    .map((categoriesObj, index: any) => {
                      return (
                        <div
                          className="compliance-wrapper__categories-details_license cursor-pointer"
                          key={index}
                        >
                          <NavLink
                            to={`/activities/task/license/region?${queryRequest}&group_id=${getValue(
                              categoriesObj,
                              `groupId`,
                              "",
                            )}`}
                          >
                            <div className="d-flex align-content-center margin">
                              <div className="lottie-wrapper">
                                <Lottie
                                  animationData={selectAnimation(
                                    getValue(
                                      categoriesObj,
                                      `business_type.text`,
                                      "",
                                    ),
                                  )}
                                  autoplay={true}
                                />
                              </div>
                              <div style={{ marginLeft: "16px" }}>
                                <h4 className="compliance-wrapper__categories-title align-center">
                                  {getValue(categoriesObj, `groupName`, "")}
                                </h4>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div className="compliance-wrapper__categories-license-list">
                  {complianceTypeList
                    .filter(
                      (categoriesObj: any) => categoriesObj.group !== null,
                    )
                    .map((categoriesObj, index: any) => {
                      return (
                        <div
                          className="compliance-wrapper__categories-details_license-list cursor-pointer"
                          key={index}
                        >
                          <NavLink
                            to={`/activities/task/license/region?${queryRequest}&group_id=${getValue(
                              categoriesObj,
                              `groupId`,
                              "",
                            )}`}
                          >
                            <div className="d-flex align-content-center margin">
                              <div className="lottie-wrapper">
                                <Lottie
                                  animationData={selectAnimation(
                                    getValue(
                                      categoriesObj,
                                      `business_type.text`,
                                      "",
                                    ),
                                  )}
                                  autoplay={true}
                                />
                              </div>
                              <div style={{ marginLeft: "16px" }}>
                                <h4 className="compliance-wrapper__categories-title align-center">
                                  {getValue(categoriesObj, `groupName`, "")}
                                </h4>
                              </div>
                            </div>
                          </NavLink>
                        </div>
                      );
                    })}
                </div>
              )
            ) : (
              <PEComplianceLicenseNotfound />
            )}
          </div>
          <div className="footer-wrapper d-flex justify-content-between">
            {complianceTypeList.length > 0 && (
              <img
                src="/images/building-illustration.svg"
                className="img-fluid"
                alt=""
              />
            )}
            {totalCount > 10 ? (
              <PaginationPage
                totalCount={totalCount}
                limit={limit}
                pageNumber={page_no}
                handleChangePagination={handleChangePagination}
                handleChangeLimit={handleChangeLimit}
                showLimit={"false"}
              />
            ) : (
              <p className="show-rows-count mt-3 d-flex">
                Total Count:&nbsp;&nbsp;{" "}
                <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
              </p>
            )}
          </div>

          {/* Certificate Download Modal */}
          <Modal
            isOpen={isCertificateModalOpen}
            toggle={handleCertificateModal}
            size="lg"
          >
            <section className="add-popup-wrapper">
              <div className="add-popup-wrapper__popup">
                <div className="add-popup-wrapper__form-group form-group">
                  Download Certificate Report
                </div>
                <div className="row flex">
                  <div className="form-group col-md-6">
                    <label htmlFor="report_name" className="rolls-label">
                      Report Name <span>*</span>
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Report Name"
                      label="Report Name"
                      className="form-control rolls-form-control"
                      id="report_name"
                      value={getValue(certificateRequest, `report_name`, "")}
                      onChange={(e: any) =>
                        setCertificateRequest({
                          ...certificateRequest,
                          report_name: sanitizeInput(e.target.value),
                        })
                      }
                      validator={simpleValidator}
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label htmlFor="report_description" className="rolls-label">
                      Report Description
                    </label>
                    <InputField
                      inputType="TEXT"
                      placeholder="Enter Report Description"
                      label="Report Description"
                      className="form-control rolls-form-control"
                      id="report_description"
                      value={getValue(
                        certificateRequest,
                        `report_description`,
                        "",
                      )}
                      onChange={(e: any) =>
                        setCertificateRequest({
                          ...certificateRequest,
                          report_description: sanitizeInput(e.target.value),
                        })
                      }
                    />
                  </div>
                </div>

                <div className="row flex">
                  <div className="form-group col-md-6">
                    <label htmlFor="expiry_date_from" className="rolls-label">
                      Expiry Date From <span>*</span>
                    </label>
                    <DatePicker
                      selectsRange={false}
                      selected={
                        getValue(certificateRequest, `expiry_date_from`, "")
                          ? new Date(certificateRequest.expiry_date_from)
                          : null
                      }
                      className="react-date-picker__inputGroup__input"
                      onChange={(date: any) => {
                        setCertificateRequest({
                          ...certificateRequest,
                          expiry_date_from: date,
                        });
                      }}
                      dateFormat="d MMM yyyy"
                      showMonthDropdown
                      showYearDropdown
                      placeholderText="Select From Date"
                      dropdownMode="select"
                      isClearable
                      disabled={isAllTime === "true"}
                    />
                    {/* {simpleValidator && (
                    <span className="form-error">
                      {simpleValidator.current.message(
                        "Expiry Date From",
                        getValue(certificateRequest, `expiry_date_from`, ""),
                        "required"
                      )}
                    </span>
                  )} */}
                  </div>

                  <div className="form-group col-md-6">
                    <label htmlFor="expiry_date_to" className="rolls-label">
                      Expiry Date To <span>*</span>
                    </label>
                    <DatePicker
                      selectsRange={false}
                      selected={
                        getValue(certificateRequest, `expiry_date_to`, "")
                          ? new Date(certificateRequest.expiry_date_to)
                          : null
                      }
                      className="react-date-picker__inputGroup__input"
                      onChange={(date: any) => {
                        setCertificateRequest({
                          ...certificateRequest,
                          expiry_date_to: date,
                        });
                      }}
                      dateFormat="d MMM yyyy"
                      showMonthDropdown
                      showYearDropdown
                      placeholderText="Select To Date"
                      dropdownMode="select"
                      minDate={
                        getValue(certificateRequest, `expiry_date_from`, "")
                          ? new Date(certificateRequest.expiry_date_from)
                          : null
                      }
                      isClearable
                      disabled={isAllTime === "true"}
                    />
                    {/* {simpleValidator && (
                    <span className="form-error">
                      {simpleValidator.current.message(
                        "Expiry Date To",
                        getValue(certificateRequest, `expiry_date_to`, ""),
                        "required"
                      )}
                    </span>
                  )} */}
                  </div>
                </div>

                <div className="row flex">
                  <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap col-md-6">
                    <label
                      htmlFor="group_id"
                      className="filter-form-wrappper__label filter-fields-label"
                    >
                      Entity / Group
                    </label>
                    <div className="filter-form-wrappper__location-input select-dd-new">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose Entity / Group"
                        className="form-control w-100"
                        name="group_id"
                        id="group_id"
                        options={groupList}
                        value={
                          groupList.find(
                            (g: any) => g.value === paramsObj.group_id,
                          ) || null
                        }
                        onChange={(e: any) => {
                          setParamsObj((prev: any) => ({
                            ...prev,
                            group_id: e.value,
                            region_id: "",
                            location_id: "",
                          }));
                        }}
                        onInputChange={(
                          inputValue: string,
                          actionMeta: any,
                        ) => {
                          if (actionMeta.action === "input-change") {
                            handleSearchRegion(inputValue);
                          }
                        }}
                        label="Entity / Group"
                      />
                    </div>
                  </div>

                  <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap col-md-6">
                    <label
                      htmlFor="region_id"
                      className="filter-form-wrappper__label filter-fields-label"
                    >
                      Region
                    </label>
                    <div className="filter-form-wrappper__location-input select-dd-new">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose Region"
                        className="form-control w-100"
                        name="region_id"
                        id="region_id"
                        options={regionList}
                        value={
                          regionList.find(
                            (g: any) => g.value === paramsObj.region_id,
                          ) || null
                        }
                        onChange={(e: any) => {
                          setParamsObj((prev: any) => ({
                            ...prev,
                            region_id: e.value,
                            location_id: "",
                          }));
                        }}
                        onInputChange={(
                          inputValue: string,
                          actionMeta: any,
                        ) => {
                          if (actionMeta.action === "input-change") {
                            handleSearchRegion(inputValue);
                          }
                        }}
                        label="Region"
                      />
                    </div>
                  </div>
                </div>

                <div className="row flex">
                  <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap col-md-6">
                    <label
                      htmlFor="location_id"
                      className="filter-form-wrappper__label filter-fields-label"
                    >
                      Unit
                    </label>
                    <div className="filter-form-wrappper__location-input select-dd-new">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose Unit"
                        className="form-control w-100"
                        name="location_id"
                        id="location_id"
                        options={locationList}
                        value={
                          locationList.find(
                            (g: any) => g.value === paramsObj.location_id,
                          ) || null
                        }
                        onChange={(e: any) => {
                          setParamsObj((prev: any) => ({
                            ...prev,
                            location_id: e.value,
                          }));
                        }}
                        onInputChange={(
                          inputValue: string,
                          actionMeta: any,
                        ) => {
                          if (actionMeta.action === "input-change") {
                            handleSearchLocation(inputValue);
                          }
                        }}
                        label="Unit"
                      />
                    </div>
                  </div>

                  <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap col-md-6">
                    <label
                      htmlFor="location_id"
                      className="filter-form-wrappper__label filter-fields-label"
                    >
                      License Type
                    </label>
                    <div className="filter-form-wrappper__location-input select-dd-new">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose License Type"
                        className="form-control w-100"
                        name="license_type_ids"
                        id="license_type_ids"
                        options={licenseTypeList}
                        isMulti
                        value={licenseTypeList.filter((item: any) =>
                          paramsObj.license_type_ids?.includes(item.value),
                        )}
                        onChange={(selected: any) => {
                          setParamsObj((prev: any) => ({
                            ...prev,
                            license_type_ids: selected
                              ? selected.map((item: any) => item.value)
                              : [],
                          }));
                        }}
                        label="license_type_ids"
                      />
                    </div>
                  </div>
                </div>

                <div className="row flex">
                  <div className="filter-form-wrappper__location-form-group form-group filter-field-children-wrap col-md-6">
                    <label
                      htmlFor="license_status"
                      className="filter-form-wrappper__label filter-fields-label"
                    >
                      License Status
                    </label>
                    <div className="filter-form-wrappper__location-input select-dd-new">
                      <InputField
                        inputType="INPUT_REACT_SELECT"
                        placeholder="Choose license status"
                        className="form-control w-100"
                        name="license_statuses"
                        id="license_statuses"
                        options={licenseStatusList}
                        isMulti
                        value={licenseStatusList.filter((item: any) =>
                          paramsObj.license_statuses?.includes(item.value),
                        )}
                        onChange={(selected: any) => {
                          setParamsObj((prev: any) => ({
                            ...prev,
                            license_statuses: selected
                              ? selected.map((item: any) => item.value)
                              : [],
                          }));
                        }}
                        label="license_statuses"
                      />
                    </div>
                  </div>

                  <div className="d-flex align-items-center flex-nowrap col-md-3">
                    <h4
                      className="header_text__blue mb-0 me-2"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      All Time
                    </h4>
                    <div className="choicelist-wrapper custom-switch-wrapper">
                      <label className="switch mb-0">
                        <input
                          type="checkbox"
                          checked={isAllTime === "true"}
                          onChange={handleToggle}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>

                  <div className="d-flex align-items-center flex-nowrap col-md-3">
                    <h4
                      className="header_text__blue mb-0 me-2"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Active
                    </h4>
                    <div className="choicelist-wrapper custom-switch-wrapper">
                      <label className="switch mb-0">
                        <input
                          type="checkbox"
                          checked={isActive}
                          onChange={handleActiveToggle}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="add-popup-wrapper__cta-wrapper">
                  <button
                    onClick={handleCertificateModal}
                    className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
                  >
                    Cancel
                  </button>
                  <button
                    className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
                    onClick={handleCertificateSubmit}
                    disabled={submitLoading}
                  >
                    {submitLoading ? "Please Wait..." : "Submit"}
                  </button>
                </div>
              </div>
            </section>
          </Modal>
        </>
      )}
    </DashboardLayout>
  );
}
